import { call, put, takeLatest } from 'redux-saga/effects';
import { getAccountDetails } from '../api'; // Import the API function
import {
  accountFetched,
  accountFetchFailed,
  accountRequest,
} from '../reducer/accountSlice';

interface AccountRequestAction {
  type: typeof accountRequest.type;
  payload: string;
}

export function* getAccountDetailsSaga(
  action: AccountRequestAction
): Generator<any, void, unknown> {
  try {
    const accountDetails: any = yield call(
      getAccountDetails,
      'account_maindetails',
      action.payload
    );
    yield put(accountFetched(accountDetails));
  } catch (error: any) {
    yield put(accountFetchFailed(error.message || 'Something went wrong'));
  }
}
